import AreaOfStudyTypeDomainService from "../../../Domain/AreaOfStudyType/AreaOfStudyType.service";
import makeAreaOfStudyLookup from "./AreaOfStudyLookup";
const MinorLookup = makeAreaOfStudyLookup(AreaOfStudyTypeDomainService.MINOR_ID);
export default MinorLookup;
